<template>
    <div
        class=""
        :style="{ backgroundColor: bgColor || '#F0F8FF' }"
    >
        <Container>
            <div class="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-6 gap-3 md:gap-6">
                <div
                    v-for="item in items"
                    :key="item.id"
                    class="rounded-xl transition-all duration-300 shadow-lg cursor-pointer overflow-hidden"
                    :class="activeItemId === item.id && !isMobile ? 'shadow-none opacity-90 scale-[0.98] translate-y-0.5' : ''"
                    :style="{ backgroundColor: activeItemId === item.id && !isMobile && colorCache[item.image] ? colorCache[item.image] : (expandedItemId === item.id && isMobile && colorCache[item.image] ? colorCache[item.image] : (cardBgColor || '#ffffff')) }"
                    @click="handleItemClick(item)"
                    @mouseenter="!isMobile && handleItemInteraction(item)"
                >
                    <!-- Desktop layout -->
                    <div class="hidden md:flex flex-col items-center text-center p-6">
                        <div class="w-24 h-24 rounded-full overflow-hidden flex-shrink-0">
                            <img
                                :src="item.image"
                                :alt="item.heading"
                                class="w-full h-full object-cover"
                                loading="lazy"
                                crossorigin="anonymous"
                            />
                        </div>
                        <h3 class="mt-4 text-base font-semibold text-black">{{ item.heading }}</h3>
                    </div>

                    <!-- Mobile layout -->
                    <div class="md:hidden">
                        <!-- Collapsed header -->
                        <div class="flex items-center p-4 gap-3">
                            <div class="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                                <img
                                    :src="item.image"
                                    :alt="item.heading"
                                    class="w-full h-full object-cover"
                                    loading="lazy"
                                    crossorigin="anonymous"
                                />
                            </div>
                            <h3 class="flex-1 text-sm font-semibold text-black text-left">{{ item.heading }}</h3>
                            <svg
                                class="w-5 h-5 text-black/50 transition-transform duration-300 flex-shrink-0"
                                :class="expandedItemId === item.id ? 'rotate-180' : ''"
                                fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
                            >
                                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
                            </svg>
                        </div>
                        <!-- Expanded content -->
                        <div v-if="expandedItemId === item.id" class="px-4 pb-4">
                            <img
                                :src="item.image"
                                :alt="item.heading"
                                class="hover:opacity-90 transition-opacity rounded-lg w-full mb-6"
                            />
                            <p v-if="item.paragraph" class="text-sm text-black/80 font-outfit">{{ item.paragraph }}</p>
                            <a
                                v-if="item.link"
                                :href="item.link"
                                target="_blank"
                                class="mt-3 inline-flex items-center text-primary-500 font-[500] text-sm font-outfit"
                                @click.stop
                            >
                                Learn more
                                <svg class="ml-1 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                     stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    </div>
</template>

<script>
import Container from '../../../../Layouts/Container.vue';
import {FastAverageColor} from 'fast-average-color';

export default {
    components: {Container},
    emits: ['item-selected'],
    props: {
        items: {type: Array, default: () => []},
        bgColor: {type: String, default: null},
        cardBgColor: {type: String, default: null},
        topPadding: {type: Number, default: null},
        bottomPadding: {type: Number, default: null},
        cardsPerRow: {type: Number, default: null},
        showShadow: {type: Boolean, default: null},
        fgColor: {type: String, default: null},
    },
    data() {
        return {
            activeItemId: null,
            expandedItemId: null,
            colorCache: {},
            fac: new FastAverageColor(),
            isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : (this.$page?.props?.isMobileUA ?? false),
        };
    },
    mounted() {
        this.precomputeColors();
        this._onResize = () => {
            this.isMobile = window.innerWidth < 768;
        };
        window.addEventListener('resize', this._onResize);
    },
    beforeUnmount() {
        this.fac.destroy();
        window.removeEventListener('resize', this._onResize);
    },
    methods: {
        async precomputeColors() {
            for (const item of this.items) {
                if (!item.image) continue;
                try {
                    const color = await this.fac.getColorAsync(item.image, {
                        algorithm: 'dominant',
                        crossOrigin: 'anonymous',
                    });
                    const [r, g, b] = color.value;
                    this.colorCache = {
                        ...this.colorCache,
                        [item.image]: `rgba(${r}, ${g}, ${b}, 0.3)`,
                    };
                } catch (e) {
                    console.warn('Could not extract color for', item.image, e);
                }
            }
        },
        handleItemClick(item) {
            if (this.isMobile) {
                this.expandedItemId = this.expandedItemId === item.id ? null : item.id;
            }
            this.handleItemInteraction(item);
        },
        handleItemInteraction(item) {
            this.activeItemId = item.id;
            this.$emit('item-selected', item);
        },
    },
};
</script>

<style scoped>
</style>
